var placeInfo = {
	isOpened:false,
	scroll:null,
	
	setDesc:function(t,d) {
		/*
		this.desconly = true;
		$("#textinfo").css("padding","10px");
		$("#textinfo").css("color","#ffffff");
		$("#textinfo").css("background-color","#000000");
		$("#textinfo").html("<h2>" + t + "</h2> <hr size='1'>" + d);
		*/
	},
	
	load: function(j) {
		var s;
		//Log.debug(j);
		
		//this.scroll = new Scroller("#textinfo","#overlay");
		
		/*
		s = "";
		s = "<h4>";
		if (j.folder.parent_folder != undefined) s += j.folder.parent_folder.city_name + " - ";
		s += j.folder.city_name;
		s += "</h4>";
		s += "<h2>" + j.place_name + "</h2>";
		*/
		
		var txt;
//		if (j.folder.parent_folder.parent_folder != null && j.folder.parent_folder.parent_folder.city_name != null) txt = j.folder.parent_folder.parent_folder.city_name + " - ";
//		else txt = "";
			
//		txt += j.folder.parent_folder.city_name;
		
		var pt;
		
		if (j.place_type == "photo") {
			pt = "ZDJĘCIE";
		} else if (j.place_type == "panorama") {
			pt = "PANORAMA";
		}
		
		//pt = j.place_name;
		
		//$("#placeside").html(pt);// + "<span>N " + j.gps_x + "&deg;<br>E " + j.gps_y + "&deg;</span>");
//		gps = $("<div style='position:absolute;left:10px;bottom:100px;color:#ffffff;z-index:9999;'>N " + player.currentView.properties.gps_x + "<br>E " + player.currentView.properties.gps_y + "</div>");
		
		if (j.description != undefined) {
			var desc = j.description.replace(/\n/g, '<br />');
			desc = desc.replace(/\r/g, '') + "<br><br><br><br><br><br>&nbsp;";
			$("#infotextcontent").html(desc);
		}
		
//		$("#textheader").html("<h1>" + j.folder.city_name + "</h1>" + txt);
		$("#textheader").html(txt);
		
		//else 
		//$("#infotextcontent").html(s + "<h2>Powiązane punkty:</h2>");

//		if (player.offline) {
//			$("#infothumb").html("<img src='data/thumb_" + j.place_id + ".jpg' width='300'>");
//		} else 
//			$("#infothumb").html("<img src='" + j.thumb + "' width='300'>");

		//$("#infothumb").html("<img src='" + j.thumb + "' width='700'>");
		
		//Log.debug(j.properties.spots);
		
		var spot;
		
		for(sid in j.properties.spots) {
			//spot = $("<a href='index.php?id=" + j.properties.spots[sid].ident + "'><img src='" + j.properties.spots[sid].place.thumb + "' width='60'></a>");
			//spot = $("<div class='panolink'><a href='index.php?id=" + j.properties.spots[sid].ident + "'><img src='" + j.properties.spots[sid].place.thumb + "' width='200' height='100'><div class='bg'><span>" + j.properties.spots[sid].place.place_name + "</span></div></a></div>");
			//$("#infotextcontent").append(spot);
		}
		
		placeInfo.hideMenu();
	},
	
	back: function() {
		//placeInfo.hideMenu();		
	},
	
	toggleMenu: function() {
		Menu.infowindow();
		/*
		if (isOpened) placeInfo.hideMenu();
		else placeInfo.showMenu();		
		*/
		event.preventDefault();
	},
	
	showMenu: function() {
		$("#textinfo").show();
		$("#infomenu").show();
		isOpened = true;

		setTimeout(function() {
			$("#textinfo").removeClass("hidden");
			$("#infomenu").removeClass("hidden");
		}, 200);
		/*
		player.addToHistory({},"Info","#info");
		player.setHistoryManager(this);
		$("#textinfo").removeClass("hidden");
		$("#textinfo").show();
		//$("#menubutton").hide();
		if (this.desconly == true) $("#infomenu").css("background-image","none");
		$("#infomenu").show();
		*/
	},
	
	hideMenuReal: function() {
		history.back();
	},
	
	hideMenu: function() {
		//$("#menubutton").show();
		$("#textinfo").addClass("hidden")
		$("#infomenu").addClass("hidden")
		
		setTimeout(function() {
				//placeInfo.scroll.jumpTo(0,0);
				$("#infomenu").hide();
				isOpened = false;
				$("#textinfo").hide();
			}, 1000);
	}
	
}